<template>
  <div class="credit-speed">
    <navigation
      custom-click-event
      :theme="{
        background: '#fff',
        color: '#333333'
      }"
      @right-click="$router.push('/privilege/withdraw/retrial/rule')"
    >
      特权卡
      <span slot="right">规则</span>
    </navigation>
    <pulldown-page
      class="credit-content"
      :refresh="init"
      is-scroll
    >
      <div class="content-header" :class="pageStatus">
        <div v-if="['BUYED', 'EXPIRED'].includes(pageStatus)" class="header-order">查看订单 ></div>
        <div v-if="pageStatus === 'BUYED'" class="header-main">
          <img src="../images/icon_head@2x.png" class="header-avatar"/>
          <div class="header-info">
            <div class="info-mobile">133***8737</div>
            <div class="info-text">提现重审卡·月卡</div>
          </div>
          <div class="header-time">
            <div class="time-text">YYYY/MM/DD过期</div>
          </div>
        </div>
        <div v-if="pageStatus === 'EXPIRED'" class="header-main expire">
          <img src="../images/icon_head@2x.png" class="header-avatar"/>
          <div class="header-info">
            <div class="info-mobile">133***8737</div>
            <div class="info-text">提现重审卡·月卡</div>
          </div>
          <div class="header-time time-expire">
            <div class="time-text">YYYY/MM/DD过期</div>
            <div class="time-btn">立即续费</div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <section class="main-box">
          <div class="box-title">
            <span class="cube small mr16"></span>
            <span class="cube mr20"></span>
            金融权益
            <span class="cube ml20"></span>
            <span class="cube small ml16"></span>
          </div>
          <div class="box-content">
            <img src="../images/img_tisuka@2x.png" class="box-left">
            <div class="box-middle">
              <div class="box-middle-title">提现重审卡</div>
              <div class="box-middle-info">权益说明：这个卡就厉害了<br>他可以给你的提现时间缩短</div>
            </div>
            <div class="box-right">查结果</div>
          </div>
          <div class="box-content">
            <img src="../images/img_tuijian@2x.png" class="box-left">
            <div class="box-middle">
              <div class="box-middle-title">专属借款产品推荐</div>
              <div class="box-middle-info">专享3+个借款产品推荐</div>
            </div>
          </div>
          <div class="box-content">
            <img src="../images/img_jujiupei@2x.png" class="box-left">
            <div class="box-middle">
              <div class="box-middle-title">拒就赔特权</div>
              <div class="box-middle-info">提现被拒享赔付特权</div>
            </div>
          </div>
        </section>
        <section class="main-box">
          <life-rights></life-rights>
        </section>
      </div>
      <div v-if="pageStatus === 'UN_BUY'" class="content-buy">
        优惠价&nbsp;&nbsp;￥29.9
      </div>
    </pulldown-page>
  </div>
</template>

<script>
import LifeRights from '../components/life-rights.vue'

export default {
  components: {
    LifeRights
  },
  data () {
    return {
      pageStatus: 'EXPIRED' // UN_BUY, BUYED, EXPIRED
    }
  },
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    init () {
      console.log('init')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.credit-speed{
  background-color: #27202E;
  height: 100%;
  .credit-content{
    background-color: #27202E;
    padding-bottom: 180px;
    /deep/.page{
      background-color: transparent;
    }
    .content-header{
      background: url(../images/img_chongshenka1@2x.png) center no-repeat #1B1625;
      background-size: 100%;
      height: 542px;
      position: relative;
      &.UN_BUY{
        background-image: url(../images/img_chongshenka1@2x.png);
      }
      &.BUYED{
        background-image: url(../images/img_chongshenka2@2x.png);
      }
      &.EXPIRED{
        background-image: url(../images/img_chongshenka3@2x.png);
      }
      .header-order{
        font-size: 20px;
        line-height: 28px;
        text-decoration: underline;
        color: #FFFFFF;
        padding-top: 160px;
        padding-right: 40px;
        text-align: right;
      }
      .header-main{
        display: flex;
        align-items: flex-end;
        margin-top: 145px;
        padding: 0 90px;
        .header-avatar{
          width: 100px;
          height: 100px;
        }
        .header-info{
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 12px;
          align-self: center;
          .info-mobile{
            font-size: 40px;
            color: #333333;
            font-weight: 500;
            line-height: 48px;
            font-family: DIN-Medium, DIN;
          }
          .info-text{
            background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
            height: 40px;
            line-height: 40px;
            border-radius: 20px;
            text-align: center;
            padding: 0 30px;
            font-size: 20px;
            color: #fff;
            margin-top: 3px;
          }
        }
        .header-time{
          margin-left: auto;
          margin-bottom: 11px;
          display: flex;
          flex-direction: column;
          .time-text{
            font-size: 20px;
            color: #333333;
          }
        }
        &.expire{
          .header-info{
            .info-text{
              color: #fff;
              background: #BDBDBD;
            }
          }
          .header-time{
            align-self: center;
            justify-content: center;
            margin-bottom: 0;
            .time-text{
              color: #888888;
            }
            .time-btn{
              background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
              line-height: 50px;
              height: 50px;
              border-radius: 40px;
              font-size: 24px;
              color: #fff;
              text-align: center;
              padding: 0 35px;
              margin-top: 10px;
            }
          }
        }
      }
    }
    .content-main{
      background-color: #27202E;
      padding-top: 20px;
      .main-box{
        padding: 40px 40px 0;
        .box-title{
          font-size: 32px;
          line-height: 45px;
          color: #FFD7A6;
          display: flex;
          justify-content: center;
          align-items: center;
          .cube{
            display: block;
            width: 12px;
            height: 12px;
            background-color: #FFD7A6;
            transform: rotate(45deg);
            &.small{
              width: 10px;
              height: 10px;
            }
            &.ml20{margin-left: 20px;}
            &.ml16{margin-left: 16px;}
            &.mr20{margin-right: 20px;}
            &.mr16{margin-right: 16px;}
          }
        }
        .box-content{
          width: 670px;
          height: 158px;
          background: url(../images/img_juxing@2x.png) center no-repeat;
          background-size: 100%;
          display: flex;
          align-items: center;
          padding: 0 30px 0 35px;
          margin-top: 20px;
          .box-left{
            width: 97px;
            height: 53px;
          }
          .box-middle{
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 30px;
            .box-middle-title{
              font-size: 30px;
              color: #1B1625;
              line-height: 42px;
            }
            .box-middle-info{
              font-size: 22px;
              color: #5C5C5C;
              margin-top: 5px;
              line-height: 30px;
            }
          }
          .box-right{
            background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
            height: 50px;
            line-height: 50px;
            padding: 0 35px;
            border-radius: 40px;
            color: #fff;
            font-size: 24px;
            margin-left: auto;
          }
        }
      }
    }
    .content-buy{
      background: linear-gradient(90deg, #FFD095 0%, #FFD9AB 100%);
      width: 630px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      border-radius: 47px;
      font-size: 36px;
      color: #423B33;
      font-weight: bold;
      margin: 88px auto 0;
    }
  }
}
</style>